export default "__VITE_ASSET__DDoPEv7e__"